import { render, staticRenderFns } from "./DvCheckbox.vue?vue&type=template&id=63ce7602&scoped=true&lang=pug"
import script from "./DvCheckbox.vue?vue&type=script&lang=js"
export * from "./DvCheckbox.vue?vue&type=script&lang=js"
import style0 from "./DvCheckbox.vue?vue&type=style&index=0&id=63ce7602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce7602",
  null
  
)

export default component.exports